// extracted by mini-css-extract-plugin
export default {"stack":"stack___B4ARl","avatar":"avatar___Qjefi","stackSmall":"stackSmall___tBbNf","avatarOverflow":"avatarOverflow___aFbem","singleTag":"singleTag___GWz9n"};